/* Look Around Apps */

//---- line item property----//
$('#gift_checkbox').change(()=>{                                    
   if(this.checked) {
    $('.form-container').fadeIn();  

    }else{
     $('.form-container').fadeOut();
     $('p.line-item-property__field > #input-id').val(" ");       
    }
 })
